import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ISyncDataFeature } from './sync-data.feature.state';
import { getFailures, getIsLoading } from './sync-data.selectors';

@Injectable()
export class SyncDataFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);

  constructor(private store: Store<ISyncDataFeature>) {}
}
